import useSWR from 'swr'

import { useCallMutation } from '@/common/api/client'
import { apiDefaultFetcher, apiPutFetcher } from '@/common/api/fetcher'
import {
  SiteIdVars,
  UpdateSettingsVars,
  W2ReviewSettings,
  W2ReviewSyncApiPath,
  W2ReviewSyncRun,
  W2ReviewSyncRunList
} from '@/common/api/params/w2ReviewSync'

/** 連携の設定と、データ基盤・UGC 双方の件数 */
export const useW2ReviewSyncSettingsApi = (vars: SiteIdVars) =>
  useSWR<W2ReviewSettings, Response, [string, SiteIdVars]>(
    [W2ReviewSyncApiPath.SETTINGS, vars],
    apiDefaultFetcher
  )

export const useW2ReviewSyncSettingsUpdateApi = (onSuccess?: (r: W2ReviewSettings) => void) =>
  useCallMutation<W2ReviewSettings, UpdateSettingsVars>(
    W2ReviewSyncApiPath.SETTINGS,
    { onSuccess },
    apiPutFetcher
  )

/** 今すぐ反映する。通常は連携ファイルの取り込み直後に自動で走る */
export const useW2ReviewSyncRunApi = (onSuccess?: (r: W2ReviewSyncRun) => void) =>
  useCallMutation<W2ReviewSyncRun, SiteIdVars>(W2ReviewSyncApiPath.RUN, { onSuccess })

/** 反映の履歴 */
export const useW2ReviewSyncRunsApi = (vars: SiteIdVars & { limit?: number }) =>
  useSWR<W2ReviewSyncRunList, Response, [string, SiteIdVars & { limit?: number }]>(
    [W2ReviewSyncApiPath.RUNS, vars],
    apiDefaultFetcher
  )
